{
  "app_notification_caption": "Unread ticker will appear on News & updates section",
  "attachment_remove": "Remove file",
  "attachment_upload_error": "Could not upload the file. Remove it and try again.",
  "attachments": "Attachments",
  "attachments_caption": "Add one or more files to the post",
  "blog": "Blog",
  "body_file_unavailable": "Could not open the file {name}",
  "bring_your_team_updates": "Bring your team updates together: start with an all-hands channel, then add more for specific topics",
  "channel_is_ready": "This channel is ready — just add your first update to get things rolling",
  "check_who_mentioned": "Check who mentioned you and reply if needed",
  "choose_bg_color": "Choose background color",
  "choose_channels": "Choose feed",
  "comments_disabled": "Comments to the post are disabled by the author",
  "comments_disabled_switch": "Disable comments to the post",
  "configure_my_feed": "Configure my feed",
  "create_channel": "Create new feed",
  "create_first_channel": "Create your first channel",
  "create_yours_feed_caption": "Click “Subscribe” on any channel you like, and it’ll start showing up in your feed — simple as that",
  "create_yours_feed_title": "Create a feed that’s yours",
  "creating_post": "Create new post",
  "delete_channel_question": "Do you want delete this feed?",
  "delete_post_question": "Do you want delete this post?",
  "edit_channel": "Edit feed",
  "editing_post": "Editing a post",
  "enter_content": "Enter post content...",
  "enter_post_content": "Enter post content...",
  "error_need_one_feed_for_publishing": "You need to select at least one feed for publishing",
  "feed_name": "Feed name",
  "for_preview": "For post preview on Home screen",
  "got_it": "Got it",
  "hero_image": "Hero image",
  "manage_channels": "Manage feeds",
  "manage_channels_description": "Create, update, or remove news feeds",
  "manage_comments": "Manage post comments",
  "manage_comments_description": "Delete comments on posts",
  "manage_posts": "Manage feed posts",
  "manage_posts_description": "Edit or remove individual posts in the feed",
  "mandatory_channel_caption": "News you would like to know",
  "more_news": "More news",
  "my_feed": "My feed",
  "new_feed": "New feed",
  "new_post": "New post",
  "news": "News",
  "news_and_updates": "Feed",
  "no_posts": "No posts yet",
  "nothing_here": "Nothing here yet",
  "nothing_here_caption": "Your feed will fill up once channels start posting updates",
  "notification_settings_blog_caption": "When posts are created or you are mentioned",
  "notify_subscribers_in": "Notify subscribers in",
  "pdf_too_large": "The PDF is larger than {size} MB",
  "pdf_unsupported_format": "Only PDF files can be uploaded",
  "post_body": "Post body",
  "post_caption": "Post caption",
  "post_title": "Post title",
  "post_without_image": "Post without image",
  "posts": "Posts",
  "preview_post": "Preview post",
  "publish": "Publish",
  "publish_to": "Publish to",
  "publish_to_caption": "Define who can create and edit content in this feed. Editors automatically have viewing access.",
  "reactions_disabled": "Reactions to the post are disabled by the author",
  "reactions_disabled_switch": "Disable reactions to the post",
  "read_more": "Read more",
  "schedule": "Schedule",
  "schedule_title": "Scheduled post. Will be published {time}",
  "scheduled_post": "Scheduled post",
  "slack_channel": "Slack channel",
  "subscribe": "Subscribe",
  "subscribe_all_employees": "Subscribe all employees",
  "subscribe_all_employees_caption": "This is an all-hands channel, visible for everyone and subscription is made by default",
  "subscribed": "Subscribed",
  "video_too_large": "The video is larger than {size} MB",
  "video_too_large_hint": "Upload it to YouTube or Vimeo and insert the link instead",
  "video_unsupported_format": "Only MP4 and WebM videos can be uploaded",
  "view_mentions": "View mentions",
  "viewers": "Viewers",
  "visible_to": "Visible to",
  "visible_to_caption": "Define who can view the content in this feed. Editors automatically have viewing access.",
  "you_have_mentions": "You have {count_mentions} in news",
  "~": ""
}
